import { FontAwesome5 } from '@expo/vector-icons';
import * as React from 'react';
import type { FlexStyle, StyleProp } from 'react-native';

import WarnMessage from '../warn-message/warn-message';

export interface SuccessMessageProps {
  onContinue: () => void;
  title: string;
  body?: string;
  continueLabel: string;
  style?: StyleProp<FlexStyle>;
}

export const SuccessMessage = ({
  onContinue,
  body,
  continueLabel,
  title,
  style,
}: SuccessMessageProps) => {
  const footerButtons = [{ label: continueLabel, onPress: onContinue }];
  return (
    <WarnMessage
      styleContainer={style}
      buttons={footerButtons}
      body={body}
      title={title}
      roundedIcon={<FontAwesome5 name="check" size={32} />}
    />
  );
};
